import styled from "@emotion/styled";

export const StyledSelectWrapper = styled("div")``;

export const StyledMultipleValueContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledMultipleValueItem = styled("span")`
  display: block;
`;
